import React from 'react';
import { makeStyles } from '@lifeomic/chroma-react/styles';

export type StatusBadgeVariant =
  | 'synced'
  | 'missing'
  | 'unavailable'
  | 'inProgress'
  | 'complete'
  | 'notAssessed'
  | 'blocked';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    maxWidth: '100%',
    padding: theme.spacing(0.5, 1.25),
    borderRadius: theme.pxToRem(12),
    fontSize: theme.typography.caption.fontSize,
    fontWeight: theme.typography.fontWeightMedium,
    lineHeight: theme.typography.caption.lineHeight,
    whiteSpace: 'normal',
  },
  synced: {
    backgroundColor: theme.palette.green[100],
    color: theme.palette.green[800],
    border: `1px solid ${theme.palette.green[300]}`,
  },
  missing: {
    backgroundColor: theme.palette.orange[100],
    color: theme.palette.orange[800],
    border: `1px solid ${theme.palette.orange[300]}`,
  },
  unavailable: {
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.grey[800],
    border: `1px solid ${theme.palette.grey[400]}`,
  },
  inProgress: {
    backgroundColor: theme.palette.blue[100],
    color: theme.palette.blue[800],
    border: `1px solid ${theme.palette.blue[300]}`,
  },
  complete: {
    backgroundColor: theme.palette.green[100],
    color: theme.palette.green[800],
    border: `1px solid ${theme.palette.green[300]}`,
  },
  notAssessed: {
    backgroundColor: theme.palette.grey[100],
    color: theme.palette.grey[800],
    border: `1px solid ${theme.palette.grey[400]}`,
  },
  blocked: {
    backgroundColor: theme.palette.orange[100],
    color: theme.palette.orange[800],
    border: `1px solid ${theme.palette.orange[300]}`,
  },
}));

type StatusBadgeProps = {
  label: string;
  variant: StatusBadgeVariant;
};

export const StatusBadge: React.FC<StatusBadgeProps> = ({ label, variant }) => {
  const classes = useStyles();

  return <span className={`${classes.root} ${classes[variant]}`}>{label}</span>;
};
